"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalBody = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _View = require("@instructure/ui-view/lib/View");
var _testable = require("@instructure/ui-testable/lib/testable.js");
var _omitProps = require("@instructure/ui-react-utils/lib/omitProps.js");
var _getComputedStyle = require("@instructure/ui-dom-utils/lib/getComputedStyle.js");
var _emotion = require("@instructure/emotion");
var _styles = _interopRequireDefault(require("./styles"));
var _theme = _interopRequireDefault(require("./theme"));
var _props = require("./props");
const _excluded = ["as", "elementRef", "overflow", "variant", "padding", "children"];
var _dec, _dec2, _class, _ModalBody;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
/**
---
parent: Modal
id: Modal.Body
---
**/
let ModalBody = exports.ModalBody = (_dec = (0, _emotion.withStyle)(_styles.default, _theme.default), _dec2 = (0, _testable.testable)(), _dec(_class = _dec2(_class = (_ModalBody = class ModalBody extends _react.Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
    this.state = {
      isFirefox: false
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);

    // We detect if -moz- prefixed style is present to identify whether we are in Firefox browser
    const style = this.ref && (0, _getComputedStyle.getComputedStyle)(this.ref);
    const isFirefox = !!(style && Array.prototype.slice.call(style).join('').match(/(?:-moz-)/));
    if (isFirefox) {
      this.setState({
        isFirefox
      });
    }
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    var _this$props$styles;
    const _this$props3 = this.props,
      as = _this$props3.as,
      elementRef = _this$props3.elementRef,
      overflow = _this$props3.overflow,
      variant = _this$props3.variant,
      padding = _this$props3.padding,
      children = _this$props3.children,
      rest = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
    const passthroughProps = _View.View.omitViewProps((0, _omitProps.omitProps)(rest, ModalBody.allowedProps), ModalBody);
    const isFit = overflow === 'fit';
    return (0, _emotion.jsx)(_View.View, Object.assign({}, passthroughProps, {
      display: "block",
      width: isFit ? '100%' : void 0,
      height: isFit ? '100%' : void 0,
      elementRef: this.handleRef,
      as: as,
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.modalBody,
      padding: padding
      // We have to make an exception in Firefox, because it makes
      //  the container focusable when it is scrollable.
      //  This is a feature, not a bug, but it prevents VoiceOver
      //  to correctly focus inside the body in other browsers.
    }, this.state.isFirefox && {
      tabIndex: -1
    }), children);
  }
}, _ModalBody.displayName = "ModalBody", _ModalBody.componentId = 'Modal.Body', _ModalBody.propTypes = _props.propTypes, _ModalBody.allowedProps = _props.allowedProps, _ModalBody.defaultProps = {
  padding: 'medium',
  as: 'div',
  variant: 'default'
}, _ModalBody)) || _class) || _class);
var _default = exports.default = ModalBody;